import { BionicNavigation, userHasValidRolesForNavItem } from '@/assets/js/constants/navigation'
import { defineNuxtRouteMiddleware, useNuxtApp, createError, showError } from 'nuxt/app'

export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp()

  // Certain pages do not require authentication. Do not require capabilities check
  if (to?.meta?.authOptional === true) {
    return
  }

  for (const navNode of BionicNavigation) {
    const isPage = to.path.includes(navNode.link) || to.fullPath.includes(navNode.link)
    if (isPage && !userHasValidRolesForNavItem(navNode, nuxtApp.$store.getters.user)) {
      throw createError({ statusCode: 404, message: 'This page does not exist', fatal: true })
    }
  }
})
